import { Injectable } from '@angular/core';
import { Const } from '../../../static/const';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ResultService {
  constructor(private http: HttpClient) {}

  getTranslateBulk(data) {
    const url = Const.connectionUrl + '/api/auto_translate_bulk';
    return this.http.post(url, data);
  }

  getTranslations(data) {
    const url = Const.connectionUrl + '/api/get_related_statements';
    return this.http.post(url, data);
  }
  getBackTranslations(data) {
    const url = Const.connectionUrl + '/api/get_back_translations';
    return this.http.post(url, data);
  }
  getAssetTypes(data) {
    const url = Const.connectionUrl + '/api/get_asset_types';
    return this.http.post(url, data);
  }

  checkAssetExist(data) {
    const url = Const.connectionUrl + '/api/check_asset_exist';
    return this.http.post(url, data);
  }

  assetUpload(data) {
    const url = Const.connectionUrl + '/api/asset_upload';
    return this.http.post(url, data);
  }

  getEditLAData(data) {
    const url = Const.connectionUrl + '/api/get_edit_las_data';
    return this.http.post(url, data);
  }

  private supportSubstantiationRedirectSubject = new BehaviorSubject<boolean>(
    false
  );
  supportSubstantiationRedirect$ =
    this.supportSubstantiationRedirectSubject.asObservable();

  setSupportSubstantiationRedirect(value: boolean) {
    this.supportSubstantiationRedirectSubject.next(value);
  }

  private savingToVeevaSubject = new BehaviorSubject<boolean>(false);
  savingToVeeva$ = this.savingToVeevaSubject.asObservable();

  setSavingToVeeva(value: boolean) {
    this.savingToVeevaSubject.next(value);
  }

  private hasUnsavedChangesSubject = new BehaviorSubject<boolean>(false);
  hasUnsavedChanges$ = this.hasUnsavedChangesSubject.asObservable();

  setHasUnsavedChanges(value: boolean) {
    this.hasUnsavedChangesSubject.next(value);
  }
}
